/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CityResponse } from '../models/CityResponse';
import type { CountryResponse } from '../models/CountryResponse';
import type { LanguageResponse } from '../models/LanguageResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GeoService {
    /**
     * Get Languages
     * @returns LanguageResponse Successful Response
     * @throws ApiError
     */
    public static getLanguagesApiGeoLanguagesGet(): CancelablePromise<Array<LanguageResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/geo/languages',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get Countries
     * @returns CountryResponse Successful Response
     * @throws ApiError
     */
    public static getCountriesApiGeoCountriesGet(): CancelablePromise<Array<CountryResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/geo/countries',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Search Cities
     * @param query
     * @returns CityResponse Successful Response
     * @throws ApiError
     */
    public static searchCitiesApiGeoSearchCitiesGet(
        query: string,
    ): CancelablePromise<Array<CityResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/geo/search-cities',
            query: {
                'query': query,
            },
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
}
